import React from 'react';
import 'twin.macro';
import { useField } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Margin } from './Margin';

interface IMargins {
  top: number;
  bottom: number;
  left: number;
  right: number;
}

interface Props {
  value: IMargins;
  onChange: (value: IMargins) => void;
}

export function Margins(props: Props) {
  const { t } = useTranslation(['common']);
  return (
    <div>
      <div tw="inline-flex flex-wrap justify-between gap-4 mb-4">
        <div>
          <div tw="text-xs">{t('common:pdf.margins.top')}</div>
          <Margin
            value={props.value.top}
            onChange={v => props.onChange({ ...props.value, top: v })}
          />
        </div>
        <div>
          <div tw="text-xs">{t('common:pdf.margins.bottom')}</div>
          <Margin
            value={props.value.bottom}
            onChange={v => props.onChange({ ...props.value, bottom: v })}
          />
        </div>
      </div>
      <div tw="inline-flex flex-wrap justify-between gap-4">
        <div>
          <div tw="text-xs">{t('common:pdf.margins.left')}</div>
          <Margin
            value={props.value.left}
            onChange={v => props.onChange({ ...props.value, left: v })}
          />
        </div>
        <div>
          <div tw="text-xs">{t('common:pdf.margins.right')}</div>
          <Margin
            value={props.value.right}
            onChange={v => props.onChange({ ...props.value, right: v })}
          />
        </div>
      </div>
    </div>
  );
}

export function MarginsFieldWrapper(props: { prefix?: string }) {
  const { prefix } = props;
  const marginTopField = useField(prefix ? `${prefix}.marginTop` : 'marginTop');
  const marginBottomField = useField(
    prefix ? `${prefix}.marginBottom` : 'marginBottom',
  );
  const marginLeftField = useField(
    prefix ? `${prefix}.marginLeft` : 'marginLeft',
  );
  const marginRightField = useField(
    prefix ? `${prefix}.marginRight` : 'marginRight',
  );

  return (
    <div>
      <Margins
        value={{
          top: marginTopField.input.value,
          bottom: marginBottomField.input.value,
          left: marginLeftField.input.value,
          right: marginRightField.input.value,
        }}
        onChange={newMargins => {
          marginTopField.input.onChange(newMargins.top);
          marginBottomField.input.onChange(newMargins.bottom);
          marginLeftField.input.onChange(newMargins.left);
          marginRightField.input.onChange(newMargins.right);
        }}
      />
    </div>
  );
}
